import i18next from "i18next";
import { notification } from "antd";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { SearchFilters, SelectFilters } from "datastake-daf/dist/components"
import {
  selectFiltersConfig as defaultSelectFiltersConfig,
  filtersConfig,
  checkboxConfig,
} from './config';
import Map from "../Map";
import { useFindInformation } from "../../store";
import { useFilters } from "../../../../helpers/SubjectSearch";
import Tabs from "../Tabs";

export default function Locations({
  mod,
  activeTab,
  setActiveTab = () => { },
}) {
  const goTo = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const {
    locations: {
      hasError,
      setHasError,
      showFilters,
      selectOptions,
      setShowFilters,
      defaultActiveFilters,
      setDefaultActiveFilters,
    }
  } = useFindInformation();
  const [api, contextHolder] = notification.useNotification();

  const {
    newFiltersConfig,
    activeFilters,
    onSearch,
    setActiveFilters,
    onFiltersChange,
  } = useFilters({
    selectFiltersConfig: defaultSelectFiltersConfig,
    doPagination: false,
    defaultActiveFilters,
    module: mod,
    filtersConfig,
  });

  const canClearSearch = useMemo(() => {
    return !!activeFilters.search;
  }, [activeFilters]);

  useEffect(() => {
    const getFiltersString = () => {
      let string = '';

      if (activeFilters.category) {
        string += `&category=${activeFilters.category}`
      }

      if (activeFilters.country) {
        string += `&country=${activeFilters.country}`
      }

      return string;
    };

    if (activeFilters.search) {
      goTo(`${location.pathname}?activeTab=locations&search=${activeFilters.search}${getFiltersString()}`);
    } else {
      goTo(`${location.pathname}?activeTab=locations${getFiltersString()}`);
    }

    setDefaultActiveFilters(activeFilters);
  }, [activeFilters]);

  return (
    <div className="column start table-content flex-1">
      {contextHolder}
      <div className='flex mt-6 ml-6 mr-6'>
        <div className="mr-2">
          <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>

        <SearchFilters
          t={t}
          showFilters={showFilters}
          setShowFilters={setShowFilters}
          hasError={hasError}
          setHasError={setHasError}
          filtersConfig={newFiltersConfig}
          checkboxConfig={checkboxConfig}
          onSearch={onSearch}
          activeFilters={activeFilters}
          canClear={canClearSearch}
          clearFilters={() => setActiveFilters({})}
        />
      </div>

      <div className='flex flex-column flex-1'>
        <SelectFilters
          language={i18next.language}
          t={t}
          options={selectOptions}
          filtersConfig={defaultSelectFiltersConfig}
          onApply={(filters) => {
            onFiltersChange(filters)
          }}
          showFilters={showFilters}
          setShowFilters={setShowFilters}
          selectedFilters={activeFilters}
        />

        <Map mod={mod} api={api} activeFilters={activeFilters} />
      </div>
    </div>
  );
}
